import React from 'react';
import { Modal } from 'react-bootstrap';

class PlanDealInfoPopup extends React.Component {

  constructor() {
    super();
    this.state = { showModal: false };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }
  close() {
    this.setState({ showModal: false });
  }
  open(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }
  render() {
    return (
      <div className="col-xs-12">
        <a href="/" onClick={this.open}>What does this mean?</a>
        <Modal dialogClassName="skinny-modal" show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton />
          <Modal.Body>
            <p className="skinny-modal-text">
               If you still have an active discount on your current broadband plan, and
                it is available on your new broadband plan, the discount will automatically carry over to your new plan with the same expiry
            </p>
          </Modal.Body>
        </Modal>
      </div>
      );
  }
}
export default PlanDealInfoPopup;



/** WEBPACK FOOTER **
 ** ./src/components/Plans/PlanDetails/PlanDealInfoPopup.js
 **/